import React from "react";
import StaffNavBar from "../components/StaffNavBar";
import { useStaffNews } from "../store/staff";
import AdminNewsManagement from "../adminPages/NewsManagement";

// Staff uses the same news UI and actions as admin, scoped to /api/staff/news.
export default function StaffNewsManagement() {
  return (
    <AdminNewsManagement
      useNewsStore={useStaffNews}
      NavbarComponent={StaffNavBar}
      detailPath="/staff/news"
    />
  );
}
